import { createPutEndpoint } from '@sonar-software/sonar-http';

export type PutBusinessContextRequest = {
	context: string;
};

export const putBusinessContext = createPutEndpoint<PutBusinessContextRequest>(
	'/api/v3/core/business-contexts'
);
